import * as graphql from '@treams/treams-network';

import { useViewerRoles } from './useViewerRoles';
import { useWorkspace } from './useWorkspace';

export function useFeature(id: graphql.FeatureName): boolean {
	const viewerRoles = useViewerRoles();

	const { data } = graphql.useFeaturesQuery({
		variables: {
			id: useWorkspace().id,
		},
		fetchPolicy: 'cache-first',
	});

	const enabledFeatures = data?.workspace.features
		.filter(
			(feature) =>
				feature.status === graphql.WorkspaceFeatureStatus.Enabled ||
				(viewerRoles.isWorkspaceSuperuser &&
					feature.status === graphql.WorkspaceFeatureStatus.Superuser),
		)
		.map(({ feature }) => feature.id);

	return enabledFeatures?.includes(id) ?? false;
}
